import { render } from "./CrmKanbanTopHeaderCreateDealModal.vue?vue&type=template&id=672ca404&scoped=true"
import script from "./CrmKanbanTopHeaderCreateDealModal.vue?vue&type=script&lang=js"
export * from "./CrmKanbanTopHeaderCreateDealModal.vue?vue&type=script&lang=js"

import "./CrmKanbanTopHeaderCreateDealModal.vue?vue&type=style&index=0&id=672ca404&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672ca404"]])

export default __exports__